module.exports = __webpack_public_path__ + "static/media/attractive-mobile-3.511dd466.jpg";